import React from 'react';
import styles from './NexsetSampleView.module.scss';
import { useNexsetSample } from './hooks';
import ResourceSelectionButton from 'new/elements/ResourceSelectionButton';
import { RESOURCE_TYPE_DATA_SET } from 'js/constants/resourceTypes';
import { ExpandView } from 'js/components/recipeBuilder/NexsetSampleView/components/ExpandView';
import { useSamples } from 'new/state/samples/repository/useSamples';
import useAppDispatch from 'js/hooks/useAppDispatch';
import { fetchDataSamples } from 'js/actions';
import useDidUpdateEffect from 'new/hooks/useDidUpdateEffect';
import useInputSamples from 'js/components/recipeBuilder/NexsetSampleView/hooks/useInputSamples';

const SORT_OPTIONS = [
  {
    value: 'LAST_CREATED_DESC',
    label: 'Last Created (Desc)',
    title: 'Last Created (Desc)',
  },
  {
    value: 'LAST_CREATED_ASC',
    label: 'Last Created (Asc)',
    title: 'Last Created (Asc)',
  },
  { value: 'NAME_ASC', label: 'Name (Asc)', title: 'Name (Asc)' },
  { value: 'NAME_DESC', label: 'Name (Desc)', title: 'Name (Desc)' },
];

const NexsetSampleView = ({ data }) => {
  const { selectedNexset, handleSelect, handleLoadSamples } = useNexsetSample();
  const { samples } = useSamples();
  const inputSample = useInputSamples(selectedNexset?.id);

  const dispatch = useAppDispatch();

  const isItemDisabled = ({ id }) => {
    return id === data.id;
  };

  useDidUpdateEffect(() => {
    if (inputSample) {
      handleLoadSamples(inputSample);
    }
  }, [inputSample]);

  const onChooseNexset = (selected) => {
    const nexset = selected[0];
    handleSelect(nexset);
    const sample = samples[nexset.id];
    if (!sample) {
      dispatch(fetchDataSamples(nexset.id));
    }
  };

  return (
    <>
      <div className={styles.loadSchemaButtonContainer}>
        <ResourceSelectionButton
          key={data?.id}
          isItemDisabled={isItemDisabled}
          onChoose={onChooseNexset}
          resourceType={RESOURCE_TYPE_DATA_SET}
          ExpandView={ExpandView}
          hideSelection
          previewActionLabel="Preview Sample Data"
        />
      </div>
    </>
  );
};

export default NexsetSampleView;
